module.exports = __webpack_public_path__ + "img/default_shipped.9edbc995.png";